import {
  CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL,
  CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR,
  UPDATE_ASSIGMENTS_ORDER_DETAIL,
  UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function updateOrderLineAssignmentReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ASSIGMENTS_ORDER_DETAIL:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
